import { useUrlFilters } from '@hooks/application/useUrlFilters';
import { parseListFilters, serializeListFilters } from './listFilterUrl';

// The list's filters, kept in the URL. Same shape as the state useScoreSpecs would otherwise own —
// `{ filters, setFilters(patch) }` — so the list hands these to the hook and nothing downstream
// knows where they live.
//
// The mechanism (the URL is the state, writes replace rather than push, two patches in one tick
// compose) is the shared hook's; this file only names the parse/serialize pair for this list.
const LIST_URL = { parse: parseListFilters, serialize: serializeListFilters };

export const useListFilterUrl = () => useUrlFilters(LIST_URL);
